import { render, staticRenderFns } from "./ManageInventory.vue?vue&type=template&id=208671cb&scoped=true"
import script from "./ManageInventory.vue?vue&type=script&lang=ts"
export * from "./ManageInventory.vue?vue&type=script&lang=ts"
import style0 from "./ManageInventory.vue?vue&type=style&index=0&id=208671cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208671cb",
  null
  
)

export default component.exports